export const ID_TOKEN = 'auth._id_token.'
export const ID_TOKEN_EXP = 'auth._id_token_expiration.'
export const REFRESH_TOKEN = 'auth._refresh_token.'
export const REFRESH_TOKEN_EXP = 'auth._refresh_token_expiration.'
